import { render } from "./BannerEducationEditorView.vue?vue&type=template&id=25d8f5c8&scoped=true"
import script from "./BannerEducationEditorView.vue?vue&type=script&lang=js"
export * from "./BannerEducationEditorView.vue?vue&type=script&lang=js"

import "./BannerEducationEditorView.vue?vue&type=style&index=0&id=25d8f5c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d8f5c8"]])

export default __exports__